import React from "react";
import "../App.css";

// Caminho do script PHP (ver send-email.php). Como o arquivo fica em
// `public/`, ele é publicado na raiz do site — ajuste aqui se você
// colocá-lo em outro caminho/domínio.
const CONTACT_ENDPOINT = "/send-email.php";

const INITIAL_FORM = {
  name: "",
  email: "",
  phone: "",
  message: "",
  website: "", // honeypot: campo escondido, deve ficar sempre vazio
};

// Seção com texto institucional à esquerda e formulário de contato à
// direita. id="formulario" é o alvo da âncora do botão "Solicitar
// Proposta" no PageHero desta página.
export default function ContactSection() {
  const [form, setForm] = React.useState(INITIAL_FORM);
  const [status, setStatus] = React.useState("idle"); // idle | sending | sent | error
  const [errorMessage, setErrorMessage] = React.useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus("sending");
    setErrorMessage("");

    try {
      const payload = new FormData();
      payload.append("name", form.name);
      payload.append("email", form.email);
      payload.append("phone", form.phone);
      payload.append("message", form.message);
      payload.append("website", form.website); // honeypot

      const response = await fetch(CONTACT_ENDPOINT, {
        method: "POST",
        body: payload,
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.message || "Não foi possível enviar sua mensagem.");
      }

      setStatus("sent");
      setForm(INITIAL_FORM);
    } catch (error) {
      setStatus("error");
      setErrorMessage(error.message || "Não foi possível enviar sua mensagem.");
    }
  };

  return (
    <section id="formulario" className="contact-section">
      <div className="contact-section__container">
        <div className="contact-section__intro">
          <span className="contact-section__eyebrow">Atendimento Consultivo</span>
          <h2 className="contact-section__title">
            Sua parceria estratégica começa aqui
          </h2>
          <p className="contact-section__text">
            Preencha o formulário ao lado para solicitar uma proposta ou
            agendar uma conversa com um de nossos consultores. Estamos
            prontos para entender suas necessidades e oferecer soluções
            personalizadas.
          </p>
        </div>

        <form className="contact-section__form" onSubmit={handleSubmit}>
          <div className="contact-section__field">
            <label htmlFor="name" className="contact-section__label">
              Nome Completo*
            </label>
            <input
              id="name"
              name="name"
              type="text"
              placeholder="Seu nome"
              value={form.name}
              onChange={handleChange}
              required
              className="contact-section__input"
            />
          </div>

          <div className="contact-section__field">
            <label htmlFor="email" className="contact-section__label">
              E-mail Profissional*
            </label>
            <input
              id="email"
              name="email"
              type="email"
              placeholder="seu@email.com"
              value={form.email}
              onChange={handleChange}
              required
              className="contact-section__input"
            />
          </div>

          <div className="contact-section__field">
            <label htmlFor="phone" className="contact-section__label">
              Telefone (WhatsApp)
            </label>
            <input
              id="phone"
              name="phone"
              type="tel"
              placeholder="(XX) XXXXX-XXXX"
              value={form.phone}
              onChange={handleChange}
              className="contact-section__input"
            />
          </div>

          <div className="contact-section__field">
            <label htmlFor="message" className="contact-section__label">
              Como podemos ajudar?*
            </label>
            <textarea
              id="message"
              name="message"
              placeholder="Descreva brevemente sua necessidade..."
              value={form.message}
              onChange={handleChange}
              required
              rows={4}
              className="contact-section__textarea"
            />
          </div>

          {/* Honeypot anti-spam: invisível para pessoas, mas bots costumam
              preencher todos os campos de um formulário, incluindo este. */}
          <div className="contact-section__honeypot" aria-hidden="true">
            <label htmlFor="website">Não preencha este campo</label>
            <input
              id="website"
              name="website"
              type="text"
              tabIndex={-1}
              autoComplete="off"
              value={form.website}
              onChange={handleChange}
            />
          </div>

          <button
            type="submit"
            className="contact-section__submit"
            disabled={status === "sending"}
          >
            {status === "sending" ? "Enviando..." : "Enviar Mensagem"}
          </button>

          {status === "sent" && (
            <p className="contact-section__success" role="status">
              Mensagem enviada! Em breve nossa equipe entrará em contato.
            </p>
          )}

          {status === "error" && (
            <p className="contact-section__error" role="alert">
              {errorMessage}
            </p>
          )}
        </form>
      </div>
    </section>
  );
}
